import jwtDecode from 'jwt-decode';

import type { Auth } from 'app/typings/auth';

export const decodeToken = (token?: string): Auth | undefined => {
  if (!token) {
    return undefined;
  }

  const decodedToken = jwtDecode<Auth>(token);

  return {
    user: decodedToken.user,
    token,
  };
};
